import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import SeriesCard from '../SeriesCard';
import styles from './styles.module.scss';
import QuotaDetails from '../QuotaDetails';
import Loading from 'components/Loading';

export const OrderSeries = ({
  selectedSeriesId,
  hasQuotaDetail,
  orderList,
  quotaDetailOrder,
  isLoading,
}) => {
  return isLoading ? (
    <Loading />
  ) : (
    <div className={styles.seriesCards}>
      {orderList.map((elem, index) => (
        <div
          className={styles.seriesRow}
          key={index}
          style={{ order: elem[0] }}
        >
          {elem[1].map((id, index) => (
            <SeriesCard
              key={id}
              seriesId={id}
              selectedSeriesId={selectedSeriesId}
              leftmostPanel={index === 0}
            />
          ))}
        </div>
      ))}
      <div className={styles.seriesRow} style={{ order: quotaDetailOrder }}>
        {hasQuotaDetail && <QuotaDetails seriesId={selectedSeriesId} />}
      </div>
    </div>
  );
};

OrderSeries.propTypes = {
  hasQuotaDetail: PropTypes.bool.isRequired,
  orderList: PropTypes.array.isRequired,
  selectedSeriesId: PropTypes.string,
  quotaDetailOrder: PropTypes.number,
};

export default enhance(OrderSeries);
